import { FC } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

type Props = {
  title: string;
  status?: string;
};

const styles = StyleSheet.create({
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    fontFamily: "SourceSerifPro",
    color: "#000000",
    fontWeight: 400,
    fontSize: "32",
    lineHeight: 1.125,
  },
  status: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 12,
    lineHeight: 1.5,
    color: "#434992",
  },
});

export const Header: FC<Props> = ({ title, status }) => {
  return (
    <View style={styles.header}>
      <Text style={styles.title}>{title}</Text>

      {status && <Text style={styles.status}>{status}</Text>}
    </View>
  );
};
